import script from "./VirtualScrollCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirtualScrollCards.vue?vue&type=script&setup=true&lang=ts"

import "./VirtualScrollCards.vue?vue&type=style&index=0&id=32cb4556&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32cb4556"]])

export default __exports__